<form [formGroup]="form">

  <section>
    <h3 i18n>Connector</h3>
    <div fxLayout="row" fxLayoutGap="8px">

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Field connector</mat-label>
        <input type="number" matInput formControlName="field_connector">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Factory connector</mat-label>
        <input type="number" matInput formControlName="factory_connector">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>
  </section>

  <section>
    <mat-divider></mat-divider>
    <h3 i18n>Optical</h3>
    <div fxLayout="row" fxLayoutGap="8px">

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Optical fusion</mat-label>
        <input type="number" matInput formControlName="fusion">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Optical fiber</mat-label>
        <input type="number" matInput formControlName="fiber">
        <mat-hint>dB/km</mat-hint>
      </mat-form-field>
    </div>
  </section>

  <section *ngIf="splitters.length > 0">
    <mat-divider></mat-divider>
    <h3 i18n> Splitter</h3>
    <div fxLayout="row wrap" fxLayoutGap="8px">

      <mat-form-field *ngIf="splitters.includes(2)" fxFlex appearance="outline">
        <mat-label i18n>Splitter 1x2</mat-label>
        <input type="number" matInput formControlName="splitter_2">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field *ngIf="splitters.includes(4)" fxFlex appearance="outline">
        <mat-label i18n>Splitter 1x4</mat-label>
        <input type="number" matInput formControlName="splitter_4">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field *ngIf="splitters.includes(8)" fxFlex appearance="outline">
        <mat-label i18n>Splitter 1x8</mat-label>
        <input type="number" matInput formControlName="splitter_8">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field *ngIf="splitters.includes(16)" fxFlex appearance="outline">
        <mat-label i18n>Splitter 1x16</mat-label>
        <input type="number" matInput formControlName="splitter_16">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field *ngIf="splitters.includes(32)" fxFlex appearance="outline">
        <mat-label i18n>Splitter 1x32</mat-label>
        <input type="number" matInput formControlName="splitter_32">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>
  </section>

  <section *ngIf="isHorizontalUnbalanced">
    <mat-divider></mat-divider>
    <h3>CTO</h3>
    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>10/90</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_1090_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_1090_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>15/85</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_1585_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_1585_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>20/80</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_2080_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_2080_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>25/75</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_2575_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_2575_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>30/70</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_3070_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_3070_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>35/65</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_3565_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_3565_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>40/60</h4>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Cascade</mat-label>
        <input type="number" matInput formControlName="cto_4060_c">
        <mat-hint>dB</mat-hint>
      </mat-form-field>

      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_4060_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>

    <div class="cto-row" fxLayout="row" fxLayoutGap="8px">
      <h4 fxFlex>1/8</h4>
      <span fxFlex></span>
      <mat-form-field fxFlex appearance="outline">
        <mat-label i18n>Attendance</mat-label>
        <input type="number" matInput formControlName="cto_18_a">
        <mat-hint>dB</mat-hint>
      </mat-form-field>
    </div>
  </section>
</form>

<mat-action-row>
  <button mat-raised-button color="primary" [disabled]="form.invalid" (click)="save()" i18n>SAVE</button>
</mat-action-row>
